export const FIELD_DATA_ATTR = 'data-bb-field';
export const FIELD_EDITABLE_ATTR = 'data-editable';

export const FIELD_ERROR_DATA_ATTR = 'data-bb-error';

export const FIELD_BB_TYPE = {
	TEXT: 'text',
	EMAIL: 'email',
	TEL: 'tel',
};
export const FIELD_BB_ERROR_TYPE = {
	REQUIRED: 'required',
	EMAIL: 'email',
	TEL: 'tel',
};
export const FIELD_BB_ERROR_STYLE = {
	TEXT: {
		COLOR: 'errorColor',
		FONT_FAMILY: 'errorFontFamily',
		FONT_WEIGHT: 'errorFontWeight',
		FONT_SIZE: 'errorFontSize',
		LINE_HEIGHT: 'errorLineHeight',
		TEXT_ALIGN: 'errorTextAlign',
		DIRECTION: 'errorDirection',
	},
	PADDING: {
		TOP: 'errorPaddingTop',
		RIGHT: 'errorPaddingRight',
		BOTTOM: 'errorPaddingBottom',
		LEFT: 'errorPaddingLeft',
	},
};

export const FIELD_BB_STYLE = {
	PADDING: {
		TOP: 'fieldPT',
		RIGHT: 'fieldPR',
		BOTTOM: 'fieldPB',
		LEFT: 'fieldPL',
	},
	TEXT: {
		PH_COLOR: 'placeholderColor',
	},
	BOX: {
		FILL: 'boxFill',
		STROKE: 'boxStroke',
		ICON_COLOR: 'boxIconColor',
	},
};

export const FIELD_EDIT_MODE = {
	PLACEHOLDER: 'placeholder',
	VALUE: 'value',
};
